"use client";

import type { ComponentProps } from "react";
import { createContext, useContext, useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import {
  Tooltip as OriginalTooltip,
  TooltipContent as OriginalTooltipContent,
  TooltipProvider as OriginalTooltipProvider,
  TooltipTrigger as OriginalTooltipTrigger,
} from "./tooltip";

const TouchContext = createContext<boolean | undefined>(undefined);
const useTouch = () => useContext(TouchContext);

export const MobileTooltipProvider = ({
  children,
  ...props
}: ComponentProps<typeof OriginalTooltipProvider>) => {
  const [isTouch, setTouch] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    setTouch(window.matchMedia("(pointer: coarse)").matches);
  }, []);

  return (
    <TouchContext.Provider value={isTouch}>
      <OriginalTooltipProvider {...props}>{children}</OriginalTooltipProvider>
    </TouchContext.Provider>
  );
};

export const MobileTooltip = (
  props: ComponentProps<typeof OriginalTooltip> & ComponentProps<typeof Popover>
) => {
  const isTouch = useTouch();
  const [open, setOpen] = useState(false);

  if (isTouch) {
    return <Popover {...props} onOpenChange={setOpen} open={open} />;
  }

  return <OriginalTooltip {...props} />;
};

export const MobileTooltipTrigger = (
  props: ComponentProps<typeof OriginalTooltipTrigger> &
    ComponentProps<typeof PopoverTrigger>
) => {
  const isTouch = useTouch();

  return isTouch ? (
    <PopoverTrigger {...props} />
  ) : (
    <OriginalTooltipTrigger {...props} />
  );
};

export const MobileTooltipContent = (
  props: ComponentProps<typeof OriginalTooltipContent> &
    ComponentProps<typeof PopoverContent>
) => {
  const isTouch = useTouch();

  return isTouch ? (
    <PopoverContent {...props} />
  ) : (
    <OriginalTooltipContent {...props} />
  );
};
